import {
  Component
} from '@angular/core';
import {
  NavController,
  NavParams,
  Refresher,
  ModalController,
  AlertController,
} from 'ionic-angular';
import { NotificationsDetailsPage } from '../notifications-details/notifications-details';
import { NavEntity } from '../../models';
import { StarmsClientProvider } from '../../providers/starms-client/starms-client';
import { TimeProvider } from '../../providers/time/time';
import Enumerable from 'linq';
import { EntitiesProvider } from '../../providers/entities/entities';
import { BannersProvider } from '../../providers/banners/banners';

const notificationsDate = '2014-01-01';

@Component({
  selector: 'page-notifications',
  templateUrl: 'notifications.html'
})
export class NotificationsPage {
  nav: NavEntity;
  notifications: Array<any> = [];
  loading: boolean;
  selectedPage: any = false;
  refresher: Refresher;
  type: string;
  id: number;
  visibilities = new Map<number, boolean>();

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private modalCtrl: ModalController,
    private entitiesProvider: EntitiesProvider,
    private starms: StarmsClientProvider,
    private time: TimeProvider,
    private alertCtrl: AlertController,
    private bannersProvider: BannersProvider
  ) { }

  ionViewDidLoad() {
    this.nav = this.entitiesProvider.currentEntity;

    let type = this.navParams.get('data').type;
    let id = this.navParams.get('data').id;
    this.loading = false;

    // Get notifications
    this.starms.get(['notificationdocuments/documents', type + 's', id], {
      from: notificationsDate,
      to: this.time.get()
    }).subscribe(notifications => {
      this.loading = true;
      this.notifications = Enumerable.from(notifications)
        .orderByDescending(x => x['creationDate'])
        .toArray();
    }, error => {
      console.log(error);
      this.loading = true;
    });
  }

  async presentAlert(element: any) {
    let alert = this.alertCtrl.create({
      title: element.title,
      message: element.message,
      buttons: [
        {
          text: 'Do not show again',
          role: 'cancel',
          handler: () => {
            this.visibilities[element.id] = false;
            localStorage.setItem('visibilities', JSON.stringify(this.visibilities));
          }
        },
        {
          text: 'Dismiss',
          role: 'dismiss',
          handler: () => {
          }
        }
      ]
    });
    await alert.present();
  }

  close() {
    this.navCtrl.pop();
  }

  refresh(refresher: Refresher) {
    this.refresher.complete();
  }

  /**
   * Open notifications details
   * @param notification notification to be opened
   */
  expand(notification: Notification) {
    this.modalCtrl.create(NotificationsDetailsPage, notification).present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/notifications/notifications.ts